<template>
  <div class="text-center">
    <v-overlay :value="spinnerState">
      <v-main>
        <h1>Loading......</h1>
        <br />
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-main>
    </v-overlay>
  </div>
</template>
<script>
import {mapGetters} from "vuex";
export default {
  name: "Loader",
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["spinnerState"]),
  },
};
</script>

<style lang="scss" scoped></style>
